import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-magento1-install-extension',
  template: require('./magento1_install_extension.component.html'),
  styles: [require('./magento1_install_extension.component.scss')]

})

export class Magento1InstallExtensionComponent extends AccordionContentComponent {

}
